import React, { PropsWithChildren } from 'react';
import { TIDProvider } from '@trimble-oss/trimble-id-react';
import useNavigate from './useNavigate';
import { PAGES } from '@/pages/PAGE_CONSTANTS';
import { client } from '../apis/tid-client';

const TIDProviderWithNavigate = ({ children }: PropsWithChildren) => {
  const navigate = useNavigate();

  const handleOnRedirectCallback = () => {
    navigate({ pageName: PAGES.HOME });
  };

  return (
    <TIDProvider
      tidClient={client}
      onRedirectCallback={handleOnRedirectCallback}
      checkRedirectUrlMatch={true}
    >
      {children}
    </TIDProvider>
  );
};

export default TIDProviderWithNavigate;
